import Vue from 'vue'
import { mapActions, mapMutations, mapState } from 'vuex'
import gigJobPartiesMixin from './gigJobPartiesMixin'
import waitForRefreshApplicationMixin from './waitForRefreshApplicationMixin'
import { getGigOffer } from '@/api/gigs/offers/offers'
import { Blockchain, BlockchainNames } from '@/constants/blockchain'
import { GigJobStages } from '@/constants/gig/gigJobStages'
import { STAGE_IN_PROGRESS } from '@/constants/job/jobStages'
import ratesMixin from '@/mixins/ratesMixin'
import Currency from '@/models-ts/Currency'
import GigOfferListItem from '@/models-ts/gigs/GigOfferListItem'
import { googleAnalyticsV2 } from '@/servicies-ts/analytics'
import { RootState } from '@/store'
import { convertToUsd } from '@/utils-ts/currencies'

export default Vue.extend({
  mixins: [gigJobPartiesMixin, waitForRefreshApplicationMixin, ratesMixin],
  computed: {
    ...mapState<RootState>({
      application: (state: RootState) => state.gigChat.application.value,
      payToFreelancerLoading: (state: RootState) => state.gig.payToFreelancerLoading,
    }),
    isPaying() {
      return this.payToFreelancerLoading[this.application?.gigId]
    },
    hasPayJob() {
      return this.isEmployer && this.application?.job?.stage === GigJobStages.IN_PROGRESS && !this.application?.isDone
    },
    hasAcceptJob() {
      return this.isEmployer && this.application.job?.stage === STAGE_IN_PROGRESS && this.application?.isDone
    },
  },
  methods: {
    ...mapMutations({
      setPayToFreelancerLoading: 'gig/setPayToFreelancerLoading',
    }),
    ...mapActions({
      signPayToFreelancerV2: 'gig/signPayToFreelancerV2',
    }),
    async payToTalent() {
      if (!this.application.offer) return

      this.setPayToFreelancerLoading({ gigId: this.application.gigId })
      try {
        const offer = GigOfferListItem.fromServer(await getGigOffer(this.application.offer.id))
        if (!offer) return

        this.signPayToFreelancerV2({
          gig: offer,
          successSign: async ({
            tx,
            walletName,
            currency,
            blockchain,
          }: {
            tx: string
            walletName: string
            currency: Currency
            blockchain: Blockchain
          }) => {
            this.sendSuccessAnalytics(tx, walletName, currency, blockchain, offer)
            await this.waitRefreshApplication()
          },
        })
      } catch (e) {
        console.error(e)
        this.setPayToFreelancerLoading({ gigId: this.application.gigId, loading: false })
      }
    },
    sendSuccessAnalytics(tx: string, walletName: string, currency: Currency, blockchain: Blockchain, offer: GigOfferListItem) {
      googleAnalyticsV2.send({
        event: 'offer-gig-payment',
        'event-content': tx,
        // @ts-ignore
        offer_id: offer.id,
        gig_id: this.application.gigId,
        block_type: BlockchainNames[blockchain],
        currency: currency.name,
        // @ts-ignore
        sum: offer.job.escrow_balance ? convertToUsd({ value: offer.job.escrow_balance, currency, rates: this.rates }) : '0',
        wallet_integration_type: walletName,
      })
    },
  },
})
